import { useCallback, useEffect, useState } from "react";
import { BookingsAPI } from "../api/bookings";

export function useBookings() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [err, setErr] = useState("");

  const reload = useCallback(async () => {
    setLoading(true);
    setErr("");
    try {
      const data = await BookingsAPI.listAdmin();
      setBookings(data || []);
    } catch (e) {
      setErr(e.message || "Failed to load bookings");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    reload();
  }, [reload]);

  const updateStatus = useCallback(async (id, status) => {
    await BookingsAPI.updateStatus(id, status);
    setBookings((prev) => prev.map((b) => (b.id === id ? { ...b, status } : b)));
  }, []);

  const deleteById = useCallback(async (id) => {
    await BookingsAPI.remove(id);
    setBookings((prev) => prev.filter((b) => b.id !== id));
  }, []);

  return { bookings, setBookings, loading, err, reload, updateStatus, deleteById };
}
